var exports = {
  "q": "DiscoveryGuildHeader.module__headerTitle___MlhmQz",
};

module.exports = exports;
